/**
 * Totals good parts from scheduled and unscheduled production windows.
 * Used for Utilization totals and unsubmitted labor ticket counts.
 */

function sumAggregatedPartBucketSums(buckets) {
  const safeBuckets = Array.isArray(buckets) ? buckets : [];
  return safeBuckets.reduce((total, { sum = 0 }) => {
    return total + sum;
  }, 0);
}

function sumPartitionedPartCounts(scheduledBuckets, unscheduledBuckets) {
  return (
    sumAggregatedPartBucketSums(scheduledBuckets) +
    sumAggregatedPartBucketSums(unscheduledBuckets)
  );
}

export { sumAggregatedPartBucketSums, sumPartitionedPartCounts };
